import httpService from "./httpService";

export { getCustomerDetail };

function getCustomerDetail() {
  return httpService.get("/customers/customerdetailsv2");
}
